// @flow
import type { Notification } from '../constants';

export function deserializeNotifications(
    rawNotificationResponse: Array<any>
): Array<Notification> {
    const notifications: Array<Notification> = [];

    for (const rawNotification of rawNotificationResponse) {
        const { notificationEvent } = rawNotification;
        const { actor, metadata } = notificationEvent;

        const notification = {
            id: rawNotification.id,
            type: notificationEvent.notificationEventEnum,
            isRead: !!rawNotification.timestampRead,
            isViewed: !!rawNotification.timestampViewed,
            timestampCreated: notificationEvent.timestampCreated,
            title: notificationEvent.title,
            body: notificationEvent.body,
            actor,
            metadata
        };

        notifications.push(notification);
    }

    return notifications;
}
